import React, { useEffect } from "react";
import { Form, Input, Button, Select, Row, Col, Tooltip, Space } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

const { TextArea } = Input;

const SeoForms = ({ slug_id, form, onFinish, iniValue }) => {


console.log(form);


  return (
    <>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        autoComplete="off"
      >
        {/* BASIC META */}
        <Row gutter={16}>

          <Col span={12}>
            <Form.Item
              label={
                <Space>
                  Title{" "}
                  <Tooltip title="The title of the page shown in search results and browser tab.">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name="title"
              rules={[{ required: true, message: "Title is required" }]}
            >
              <Input placeholder="Enter meta title" allowClear />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label={
                <Space>
                  Meta Description{" "}
                  <Tooltip title="A short summary of the page content used in search engine snippets.">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name="meta_description"
              // rules={[{ required: true, message: "Meta description is required" }]}
            >
              <Input placeholder="Enter meta description" allowClear />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label={
                <Space>
                  Meta Keywords{" "}
                  <Tooltip title="Keywords separated by commas for search engine optimization (SEO).">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name="meta_keywords"
            >
              <Input placeholder="keyword1, keyword2, keyword3" allowClear />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label={
                <Space>
                  Canonical URL{" "}
                  <Tooltip title="The preferred URL for search engines to avoid duplicate content issues.">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name="canonical_url"
            >
              <Input placeholder="https://example.com/page" allowClear />
            </Form.Item>
          </Col>
        </Row>

        {/* ICONS & ROBOTS */}
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label={
                <Space>
                  Favicon Icon URL{" "}
                  <Tooltip title="URL for the small icon displayed in the browser tab.">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name="favicon"
            >
              <Input placeholder="/favicon.ico or full URL" allowClear />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label={
                <Space>
                  Meta Robots{" "}
                  <Tooltip title="Rules for search engines about indexing and following links.">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name="meta_robots"
            >
              <Select placeholder="Select robots rule" allowClear>
                <Select.Option value="index, follow">index, follow</Select.Option>
                <Select.Option value="noindex, nofollow">noindex, nofollow</Select.Option>
                <Select.Option value="index, nofollow">index, nofollow</Select.Option>
                <Select.Option value="noindex, follow">noindex, follow</Select.Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>

        {/* OPEN GRAPH */}
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label={
                <Space>
                  OG URL{" "}
                  <Tooltip title="The canonical URL used for Open Graph (social media sharing).">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name="og_url"
            >
              <Input placeholder="https://example.com" allowClear />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label={
                <Space>
                  OG Image URL{" "}
                  <Tooltip title="Image used when sharing the page on social media platforms.">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name="og_image"
            >
              <Input placeholder="https://example.com/og-image.jpg" allowClear />
            </Form.Item>
          </Col>
        </Row>

        {/* TWITTER */}
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label={
                <Space>
                  Twitter Card{" "}
                  <Tooltip title="Type of Twitter card to display when sharing the page.">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name="twitter_card"
            >
              <Select placeholder="Select twitter card type" allowClear>
                <Select.Option value="summary">summary</Select.Option>
                <Select.Option value="summary_large_image">summary_large_image</Select.Option>
              </Select>
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label={
                <Space>
                  Twitter Description{" "}
                  <Tooltip title="Description for Twitter card preview.">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name="twitter_description"
            >
              <Input placeholder="Twitter meta description" allowClear />
            </Form.Item>
          </Col>
        </Row>

        {/* RAW HTML / JSON */}
        <Form.Item
          label={
            <Space>
              application/ld+json{" "}
              <Tooltip title="Paste structured data JSON-LD schema for SEO and rich snippets.">
                <InfoCircleOutlined />
              </Tooltip>
            </Space>
          }
          name="json_ld"
        >
          <TextArea rows={5} allowClear placeholder="Paste JSON-LD schema here" />
        </Form.Item>

        <Form.Item
          label={
            <Space>
              Head (Raw HTML){" "}
              <Tooltip title="Custom HTML to be inserted into the head section of the page.">
                <InfoCircleOutlined />
              </Tooltip>
            </Space>
          }
          name="head_html"
        >
          <TextArea rows={4} placeholder="<meta> <link> <script>..." allowClear />
        </Form.Item>

        <Form.Item
          label={
            <Space>
              Body (Raw HTML){" "}
              <Tooltip title="Custom HTML to be inserted into the body section of the page.">
                <InfoCircleOutlined />
              </Tooltip>
            </Space>
          }
          name="body_html"
        >
          <TextArea rows={4} placeholder="<div>Body content</div>" allowClear />
        </Form.Item>

        <Form.Item
          label={
            <Space>
              Footer (Raw HTML){" "}
              <Tooltip title="Custom HTML to be inserted into the footer section of the page.">
                <InfoCircleOutlined />
              </Tooltip>
            </Space>
          }
          name="footer_html"
        >
          <TextArea rows={4} placeholder="<footer>Footer content</footer>" allowClear />
        </Form.Item>

        <Form.Item style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button type="primary" htmlType="submit">
            Save SEO Data
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default SeoForms;
